import { store } from '~/plugins/vuex';

function hasEntitlement(entitlement) {
  const { user } = store.state.auth;
  const isLoggedIn = !!user;

  if (!isLoggedIn) return false;

  return user.entitlements.includes(entitlement);
}

function hasOnlyOwnCatalogData() {
  const { user } = store.state.auth;
  const isLoggedIn = !!user;

  if (!isLoggedIn) return false;

  return user.showOnlyMyCatalogData;
}

function hasRole(role) {
  const { user } = store.state.auth;
  const isLoggedIn = !!user;

  if (!isLoggedIn) return false;

  return user.roles.includes(role);
}

function getUser() {
  const { user } = store.state.auth;

  return user;
}

export function useAuth() {
  return {
    getUser,
    hasEntitlement,
    hasOnlyOwnCatalogData,
    hasRole,
  };
}
